import Base from '../Base';
export default class NousJoindre extends Base {
    init(id, main, locale) {
        console.log(':: NousJoindre ::');

        var wpcf7Elm = document.querySelectorAll('.wpcf7');

        wpcf7Elm.forEach(item => {
            item.addEventListener('wpcf7invalid', event => {
                $('.notValid').removeClass('notValid');
                $('.wpcf7-not-valid').parents('label').addClass('notValid');
            }, false);

            item.addEventListener('wpcf7mailsent', event => {
                item.querySelector('.hideform').style.display = 'none';
                item.querySelector('.formContent').innerHTML += '<div class="sentForm"><h2><span>Merci</span></h2><p>Votre message a été envoyé.</p></div>';
            }, false);
        });

        $('.navJoin-link').on('click', () => {
            $('.notValid').removeClass('notValid');
            $('.wpcf7-not-valid').parents('label').addClass('notValid');
        });

        jQuery('.inputfile').change(function() {
            if (jQuery(this).val() == '') {
                jQuery('#labelFile').text('Choisir un document');
            } else {
                jQuery('#labelFile').text(jQuery(this).val());
            }
        });
        jQuery(document).ready(()=> {
            jQuery('.navJoin').each(function() {
                var highestBox = 0;
                jQuery('.navJoin-link', this).each(function() {
                    if (jQuery(this).height() > highestBox) {
                        highestBox = jQuery(this).height();
                    }
                });

                jQuery('.navJoin-link', this).height(highestBox);
            });

            var heightContent = jQuery('.navJoin').height();
            jQuery('.tab-content .tab-pane').css('min-height', heightContent);

            if ($(window).width() > 767) {
                $('#v-pills-usager-tab').addClass('active');
                $('#v-pills-usager-tab').attr('aria-selected', 'true');
                $('#v-pills-usager').addClass('show active');
            }
        });

        $('a[data-toggle="tab"]').on('shown.bs.tab', e => {
            $('html, body').animate({
                scrollTop: $(e.currentTarget.getAttribute('href')).offset().top,
            }, 500);

            return false;
        });
    }
}